import styled from "styled-components";

const CardSection = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  padding: 0 20px;
  margin: 0 auto;
  max-width: 1100px;
`;

export default CardSection;
